const transformContentResponse = (response) => {
  let contentMap = {};

  response.components.forEach((component) => {
    const name = component.name;

    component.fields.forEach((field) => {
      contentMap = {
        ...contentMap,
        [`${name}-${field.key}`]: field.value,
      };
    });
  });

  return contentMap;
};

export default transformContentResponse;
